// CustomBeacon.jsx
import React from 'react';

const CustomBeacon = ({ onClick }) => (
  <div className="my-joyride-beacon-wrapper" onClick={onClick}>
    <span className="my-joyride-beacon-outer" />
    <span className="my-joyride-beacon-inner" />
  </div>
);

export default CustomBeacon;
